import React, { useEffect, useState } from 'react'
import "../css/nav.css"

const Nav = () => {
    const [show, setShow] = useState(false);

    useEffect(() =>{
        window.addEventListener("scroll", () => window.scrollY > 100 ? setShow(true) : setShow(false)
        )
    }, [])

  return (
    <div className={`nav ${show && 'nav_black'}`}>
        <img 
        className='nav_logo'
        src="https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg" alt="Netflix Logo" />

        <img 
        className='nav_profile_icon'
        src="https://pixabay.com/get/g0d4d8f3a7323a8608823e793ab2dc6bb9d111b00b57974c6e38a35b207b7367bae6271677deb7024a29323c5bee202711d82f719339b2e9c2f7d9544082e69701b96f73c11537931d3e66d0bbda4ccac_1920.png" alt="Profile Icon" />
    </div>
  )
}

export default Nav